<div class="tw-flex tw-flex-col tw-h-full tw-overflow-hidden">
  <!-- Header -->
  <div class="tw-grid tw-grid-cols-[40px_1fr_40px] tw-w-full tw-h-18 tw-px-6 tw-bg-black tw-z-[100] tw-items-center tw-flex-shrink-0">
    <div class="tw-h-10 tw-w-10 tw-flex tw-items-center tw-justify-center tw-rounded-xl" (click)="back()">
      <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50" [iconName]="'arrow_back'"></cs-icon>
    </div>
    <span class="tw-text-300 tw-text-white tw-font-lexend tw-font-normal tw-justify-self-center" i18n="@@reviewOrder">Review Order</span>
    <div></div>
  </div>

  <!-- Scrollable content -->
  <div class="tw-flex-1 tw-min-h-0 tw-overflow-y-auto">
    @if (loading()) {
      <div class="tw-flex tw-items-center tw-justify-center tw-h-full">
        <loading class="tw-justify-center tw-self-center"></loading>
      </div>
    } @else {
      @if (isRegimenReorder()) {
        <app-regimen-reorder-card
          [reorderKit]="reorderKit()"
          [regimenClass]="regimenClass()"
          [showDoctorCharges]="showDoctorCharges()"
          [kitImage]="checkoutKitImage()"
        />
      } @else {
        <app-regimen-details [regimen]="regimen()" [user]="user()" />
      }
      <app-to-pay [pricingDetails]="pricingDetails()" [bottomsheetData]="bottomsheetData()"/>
    }
  </div>

  <!-- Footer CTA -->
  @if (!loading()) {
    <div class="tw-flex-shrink-0">
      @if (hasDefaultAddress()) {
        <app-delivery-address-bar
          [address]="defaultAddress()"
          (changeAddress)="navigateToAddresses()"
        />
      } @else if (!showLocationAutofillCta()) {
        <app-social-proof-bar />
      }
      <div class="tw-px-6 tw-py-5">
        <button csButton
                type="button"
                class="tw-w-full tw-capitalize tw-max-w-full"
                [loading]="(checkoutInProgress$ | async)"
                [attr.data-testid]="checkoutCtaTestId()"
                (click)="handleCheckout()"
        >
          @if (this.hasDefaultAddress()) {
            @if (isRegimenReorder()) {
              <span i18n="@@proceedToPay">Proceed to pay</span>
            } @else {
              <span i18n="@@makePayment"> Make payment </span>
            }
          } @else if (showLocationAutofillCta()) {
            <span i18n="@@addAddressManually"> Add address manually </span>
          } @else {
            <span i18n="@@addAddressText">Add Address</span>
          }
        </button>
        @if (showLocationAutofillCta()) {
          <button csButton="outlined"
                  id="reviewOrderUseMyLocation"
                  type="button"
                  class="tw-mt-3 tw-w-full tw-capitalize tw-max-w-full"
                  [loading]="autofillSaveInProgress()"
                  (click)="startLocationAutofill()"
                  i18n="@@useMyCurrentLocationCta">Use my current location</button>
        }
        @if (expectedDeliveryDate()?.from && expectedDeliveryDate()?.to) {
          <app-expected-delivery-date
            [expectedDeliveryDate]="expectedDeliveryDate()"
            [dayDifference]="orderDeliveryDateToCurrentDateDifference()"
          />
        }
      </div>
    </div>
  }
</div>
